import { UserState } from 'slices/User/UserSlice';

export const stateKey = 'HallmarkLoveuaryUser';

interface LocalStorageState {
  user: UserState;
}

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem(stateKey);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState) as LocalStorageState;
  } catch (err) {
    return undefined;
  }
};

export const saveState = (state: any) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(stateKey, serializedState);
  } catch {
    console.log('Could not save state to local storage');
  }
};
